import { render, staticRenderFns } from "./CategoryBreadcrumbs.vue?vue&type=template&id=d2e6cb2a&scoped=true&"
import script from "./CategoryBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./CategoryBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryBreadcrumbs.vue?vue&type=style&index=0&id=d2e6cb2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e6cb2a",
  null
  
)

export default component.exports